'use strict';

import NumberView from './Number';

class IntegerField extends NumberView{
}

export default IntegerField;
